/**
 * Une activité poussée en live (« newTodo ») est lue par l'app de l'autre bout, dont on ne connaît
 * pas la version. Le backend n'envoie les marques de rôle d'un énoncé (consigne, donnée, notion,
 * piège) qu'à une app qui les déclare (`data/clientFeatures.js`) ; le live, lui, ne passe pas par le
 * backend. Un tuteur à jour pousserait donc l'énoncé marqué à un élève resté sur un ancien bundle,
 * qui en afficherait le début de certaines lignes en double.
 *
 * L'activité voyage donc sans marques — ce que toute version sait afficher — et l'énoncé marqué
 * l'accompagne à part — ses seuls champs marqués, pour ne pas doubler le message —, dans un champ
 * qu'une ancienne app ignore. Une app à jour le reprend.
 */
const ENONCE_ROLE_MARK =
    /<span class="enonce-(?:consigne|donnee|notion|attention)">([\s\S]*?)<\/span>/g
const MARKED_FIELDS = ["statement", "body", "text"]

const withoutMarks = (value) =>
    typeof value === "string" ? value.replace(ENONCE_ROLE_MARK, "$1") : value

/** Le corps d'un « newTodo » tel qu'il part : l'activité sans marques, l'énoncé marqué à côté. */
export function toLiveTodoPayload(data) {
    const material = data?.activity?.material
    if (
        !material ||
        !MARKED_FIELDS.some(
            (field) => withoutMarks(material[field]) !== material[field]
        )
    ) {
        return data
    }
    const plain = { ...material }
    const marked = { id: material.id }
    MARKED_FIELDS.forEach((field) => {
        plain[field] = withoutMarks(material[field])
        marked[field] = material[field]
    })
    return {
        ...data,
        activity: { ...data.activity, material: plain },
        markedMaterial: marked,
    }
}

/** L'activité reçue, avec son énoncé marqué quand il a voyagé à côté. */
export function fromLiveTodoPayload(eventData) {
    const activity = eventData?.activity ?? null
    const marked = eventData?.markedMaterial
    if (!activity || !marked || marked.id !== activity.material?.id)
        return activity
    return { ...activity, material: { ...activity.material, ...marked } }
}
